import { memo } from 'react'
import { SxProps } from '@mui/material'
import clsx from 'clsx'
import { Box } from '@/components/Layout'
import { inputAdornmentStyles as styles } from './InputAdornments.style'
import { EndAdornmentProps, StartAdornmentProps } from './InputAdornments.types'
import { inputClasses } from '../Input.data'

function StartAdornment({ sx, shrinkLabel, className = '', ...props }: StartAdornmentProps) {
  return (
    <Box
      sx={[styles.adornment, styles.startAdornment, sx] as SxProps}
      className={clsx({
        [inputClasses.label.shrink]: shrinkLabel,
        [className]: Boolean(className),
      })}
      {...props}
    />
  )
}

function EndAdornment({ sx, ...props }: EndAdornmentProps) {
  return <Box sx={[styles.adornment, sx] as SxProps} {...props} />
}

const MemoStartAdornment = memo(StartAdornment)
const MemoEndAdornment = memo(EndAdornment)
export { MemoStartAdornment as StartAdornment, MemoEndAdornment as EndAdornment }
